import { FETCH_APP_CONFIG } from './actionTypes';
import { ApiAddresses } from '../common/apiAddresses';
import api from '../operations/api/api';
import {pathOr} from 'ramda';

export const fetchAppConfig = function() {
   
    return dispatch => {
        const url = ApiAddresses.fetchConfig;
        api()
        .get(url)
        .then(response => {
            const resp = pathOr([], ['data', 'response'], response);
            let appConfig= [];
            resp.forEach(config => {
                appConfig.push({ [config.name]: config.value === "true" });
            });
            if(appConfig && appConfig.length) {
                dispatch({type: FETCH_APP_CONFIG, payload: appConfig });
            }
        })
    };
};
